import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/cjs/styles/prism";

const MarkdownRenderer = ({ content }) => {
  if (!content) return null;

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        code({ node, inline, className, children, ...props }) {
          const match = /language-(\w+)/.exec(className || "");
          if (!inline && match) {
            return (
              <SyntaxHighlighter
                style={oneDark}
                language={match[1]}
                PreTag="div"
                customStyle={{
                  borderRadius: "8px",
                  fontSize: "13px",
                  margin: "8px 0",
                  overflow: "auto",
                }}
                {...props}
              >
                {String(children).replace(/\n$/, "")}
              </SyntaxHighlighter>
            );
          }
          return (
            <code
              style={{
                backgroundColor: "rgba(0,0,0,0.06)",
                padding: "2px 6px",
                borderRadius: "4px",
                fontSize: "13px",
                fontFamily: "'SF Mono', 'Fira Code', monospace",
              }}
              {...props}
            >
              {children}
            </code>
          );
        },
        p({ children }) {
          return <p style={{ margin: "0 0 8px", lineHeight: 1.6 }}>{children}</p>;
        },
        ul({ children }) {
          return <ul style={{ margin: "4px 0", paddingLeft: "20px" }}>{children}</ul>;
        },
        ol({ children }) {
          return <ol style={{ margin: "4px 0", paddingLeft: "20px" }}>{children}</ol>;
        },
        li({ children }) {
          return <li style={{ marginBottom: "4px" }}>{children}</li>;
        },
        table({ children }) {
          return (
            <div style={{ overflowX: "auto", margin: "8px 0" }}>
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  fontSize: "13px",
                }}
              >
                {children}
              </table>
            </div>
          );
        },
        th({ children }) {
          return (
            <th
              style={{
                border: "1px solid #ddd",
                padding: "6px 10px",
                backgroundColor: "#f5f5f5",
                fontWeight: 600,
                textAlign: "left",
              }}
            >
              {children}
            </th>
          );
        },
        td({ children }) {
          return (
            <td style={{ border: "1px solid #ddd", padding: "6px 10px" }}>
              {children}
            </td>
          );
        },
        a({ href, children }) {
          return (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#825ee7" }}
            >
              {children}
            </a>
          );
        },
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
